import { render, staticRenderFns } from "./cbuylist.vue?vue&type=template&id=490080e0&"
import script from "./cbuylist.vue?vue&type=script&lang=js&"
export * from "./cbuylist.vue?vue&type=script&lang=js&"
import style0 from "./cbuylist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports